// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__RvrSO","buttons":"RemoveExpirationActionButtons_buttons__30YGn"};